import { createStyles } from "@mantine/core";

export const useStyles = createStyles(theme => ({
    wrapper : {
        boxShadow : "none",
        "section" : {
            boxShadow : 'none',
            padding : 10,
            marginBottom : 20,
            width : 500,
            "button" : { fontFamily : 'Regular' , fontWeight : "bold" },
            'thead' : {
                fontFamily : 'Regular'
            },
            'tr' : {
                'td' : {
            "button" : { fontFamily : 'Regular' , fontWeight : "normal" },
                }
            }
        }
    },
    btn : {
        width : 100
    },
    modal : {
        display : 'flex',
        flexDirection : 'column',
        rowGap : 20,

    },
    confirm : {
        color : 'black',
        fontSize : 20,
        textAlign : 'center',
        fontFamily : `Regular , ${theme.fontFamily}`,
        
    },
    actions : {
        marginTop: 50,
        display : 'flex',
        columnGap : 20,
        alignItems : 'center',
        justifyContent : "center"
    },
    cancel : {
        fontFamily : `Bold , ${theme.fontFamily}`,
        fontSize : 15,
       color : theme.colors.secondary[0],
       textDecoration : "none",
       ":hover" : {
           cursor : "pointer"
       }
    }
}))